export default __webpack_public_path__ + "static/media/soehne-web-halbfett.9a86ae94.woff2";